export default __webpack_public_path__ + "static/minsu.kim-cf186d7f0d7f97ceb0dec96125fa5815.png";